/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.FeaturesRpc
 */

export const getEnabledFeaturesRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.FeaturesRpc',
  rpcName: 'getEnabledFeatures',
  auth: 'external',
  fingerprint: 'eUF899BQJjugy3Z4s1UNK0WCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};